import { commonService } from './commonService';

const apiBase = process.env.REACT_APP_API_URL;

export const userAccountService = {
    login,
    logout
}

function login(username, password) {

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    };
      /*eslint-disable*/
    console.log('requestOptions');
    console.log(requestOptions);
    console.log(apiBase);
    return fetch(apiBase+'UserAccounts/authenticate', requestOptions)
        .then(commonService.handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
            }
            return user;
        });
}

function logout() {
    // remove user from local storage to log user out
  localStorage.removeItem('user');
}